import { AxiosResponse } from 'axios';
import { clearLocalStorage } from '../../../utilities/common/storage';
import { clearAuthTokenData } from '../../../utilities/common/token';
import { isAuthChallengeRequest } from '../../constants/identity';

const onResponseFulfilled = (response: AxiosResponse) => {
  console.log('%c Response: ', 'background: #0f0; color: #fff', response);
  return response.data;
};

const onResponseRejected = (error: any) => {
  console.log('%c Error: ', 'background: #f00; color: #fff', error.response);

  const overrideCode: string | undefined =
    error.response?.data?.override?.code;
  const isMfaSignal =
    typeof overrideCode === 'string' && overrideCode.startsWith('MFA-');

  if (
    error.response &&
    [401, 403].includes(error.response.status) &&
    !isAuthChallengeRequest(error.config?.url) &&
    !isMfaSignal
  ) {
    clearAuthTokenData();
    clearLocalStorage();
    window.location.reload();
  }
  return Promise.reject(error.response);
};

export { onResponseFulfilled, onResponseRejected };
